import { render, staticRenderFns } from "./CategoryServices.vue?vue&type=template&id=48216c0b&scoped=true&"
import script from "./CategoryServices.vue?vue&type=script&lang=js&"
export * from "./CategoryServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48216c0b",
  null
  
)

export default component.exports